import React, { Component } from "react";
import UserContext from "../context/userContext";
import { getLandRegistarReport } from "../services/reportService";
import "../styles/landregistry.css";
// import "../styles/stages.css";
import { loadImage, scrollWorkAreaToTop } from "./../services/uiService";
import SearchLandForm from "./forms/searchLandForm";

import SearchLandResultsForm from "./forms/searchLandResultForm";

import PaymentDetailsForm from "./forms/paymentDetailsForm";
import PaymentConfirmForm from "./forms/paymentConfirmForm";
//import MyPayment from "./../components/mypayment";
import ErrorPopupForm from "./forms/errorPopupForm";
import {BrowserView, MobileView,isBrowser,isMobile} from 'react-device-detect';
import {setShow, setIsFlushed, setAdditionSearchResults, setSearchResult, setDataField, setPaymentResult, setEmail, setErrorState, setReceiptId} from "./../redux/slices/landSearchSlice";
import {setFeeValue, setPaymentField, returnFromError} from "./../redux/slices/paymentSlice";
import { connect } from 'react-redux';

class LandRegister extends Component {
  static contextType = UserContext;
  searchForm = "searchForm";
  searchResults = "searchResults";
  paymentDetails = "paymentDetails";
  paymentsConfirm = "paymentsConfirm";
  showError = "ShowError";
  errorPageOpened = "";
  paymentPageId = "LandRegistryPageAnimation";
  
  /* before redux
  state = {
    propertyNum: "",
    land_no: "",
    block_no: "",
    LGA: "",
    SurveyPlan_No: "",
    CofO_No: "",
    stage: 1,
    show: this.searchForm,
    // show: this.props.match.params.show
    //   ? this.props.match.params.show
    //   : this.searchForm,
    errorTitle: "",
    errorMessage: "",
    errorLinkTo: "",
    errorLinkTitle: "",
    errorLinkClassName: "",
    ownerId: "",
    webUserId: "",
    receiptId: 0,
    billingDetails:"",
    FirstName: "",
    LastName: "",
    Email: "",
    IDNumber: "",
    IDType: ""
  };
*/

  constructor(props) {
    super(props);

     this.state = {
      localLandId: ""
    };

    /*redux
    this.state = {
      propertyNum: "",
      stage: 1,
      // show: this.searchForm,
      show: this.props.match.params.show
        ? this.props.match.params.show
        : this.searchForm,
      errorTitle: "",
      errorMessage: "",
      ownerId: "",
      webUserId: "",
      isFlushed: false,
      paymentResult:""
    };
    */

    
    

    console.log("IN CONSTRAVCTOR");
    //  let logintype = this.props.match.params.show;
    this.checkStageClass = this.checkStageClass.bind(this);
    this.endCurrentStage = this.endCurrentStage.bind(this);
    this.updateSearchLandResults = this.updateSearchLandResults.bind(this);
    this.updatePaymentResults = this.updatePaymentResults.bind(this);
    this.clickSearchLand = this.clickSearchLand.bind(this);
    this.updateErrorMessage = this.updateErrorMessage.bind(this);
    this.backToPrevStage = this.backToPrevStage.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    const showValue = match?.params?.show ?? "searchForm"; // fallback to your default
    this.props.setShow(showValue); 

    //This part is for disable animation after closing errorPopup component
    this.isBrowser = typeof window !== 'undefined';
    this.isMobile = this.isBrowser && /Mobi|Android/i.test(navigator.userAgent);
    
    this.errorPageOpened = localStorage.getItem("AlertWindow");
    console.log("this.errorPageOpened: " + this.errorPageOpened);
    if(this.isBrowser)
    {
      this.paymentPageId =
      this.errorPageOpened !== undefined && this.errorPageOpened != null
        ? "LandRegistryPage"
        : "LandRegistryPageAnimation";
    }
    if(this.isMobile && this.errorPageOpened !== undefined && this.errorPageOpened != null)
    {
      this.paymentPageId = "LandRegistryPageAnimation";
    }
    
    localStorage.removeItem("AlertWindow");

    if (this.paymentPageId === "LandRegistryPageAnimation" || this.paymentPageId === "LandRegistryPage") {
      const timer = setTimeout(() => {
        var content = document.getElementById("Content");
        content.style.visibility = "visible";
        clearTimeout(timer);
      }, 600);
    } else {
      document.getElementById("Content").style.visibility = "visible";
    }
  }
/*
  componentWillReceiveProps(nextProps) {
    if (this.state.isFlushed) {
      this.setState({ isFlushed: false });
      window.location.href = window.location.href;
    }
    // since we assigned the location.state in <Link>, if we see this prop, and the data is not flushed yet, then flush data, in this case we call loadDeals(), which is a redux action
    if (!this.state.isFlushed && nextProps.location.state === "flushDeal") {
      this.setState(
        {
          isFlushed: true,
        },
        () => this.loadDeals()
      );
    }
  }
*/

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      scrollWorkAreaToTop();
    }

    /* before redux
    if (this.state.isFlushed) {
      this.setState({ isFlushed: false });
      window.location.href = window.location.href;
    }
      */

    const { isFlushed, location, searchResult, additionSearchResults, billingDetails, setFeeValue } = this.props;

    if (isFlushed) {
    {
      this.props.setIsFlushed(false);
      window.location.href = window.location.href;
    }

    // Check if nextProps.location.state is "flushDeal" and it has changed from the previous props
    /*redux
    if (!this.state.isFlushed && this.props.location.state === "flushDeal" && this.props.location.state !== prevProps.location.state) {
      this.setState(
        {
          isFlushed: true,
        },
        () => this.loadDeals()
      );
    }*/

    if (!isFlushed &&
    location.state === "flushDeal" &&
    location.state !== prevProps.location.state
      ) {
        this.props.setIsFlushed(true);
        this.loadDeals();
      }
    }

    // Detect changes in props
    const searchResultChanged = prevProps.searchResult !== searchResult;
    const additionSearchResultsChanged =
    prevProps.additionSearchResults !== additionSearchResults;

    // Initialize values
    let searchJSON = "";
    let additionSearchJSON = "";
    let propertyName = "";
    let LandId = "";

    if (searchResultChanged && searchResult !== undefined) {
      try {
        searchJSON = JSON.parse(searchResult);
        if (searchJSON[0]?.LAND_NO !== undefined)
          propertyName = searchJSON[0].LAND_NO;
        if (searchJSON[0]?.LAND_ID !== undefined)
          LandId = searchJSON[0].LAND_ID;
      } catch (err) {
        console.error("Error parsing searchResult:", err);
      }
    }

    if (additionSearchResultsChanged && additionSearchResults) {
      try {
        additionSearchJSON = JSON.parse(additionSearchResults);

        const table1 = additionSearchJSON?.Table1?.[0];
        const table2 = additionSearchJSON?.Table2?.[0];

        if (table1?.LAND_NO !== undefined) propertyName = table1.LAND_NO;
        if (table1?.LAND_ID !== undefined) LandId = table1.LAND_ID

        if (table2?.VALUE !== undefined) {
          setFeeValue(table2.VALUE);
        }
      } catch (err) {
        console.error("Error parsing additionSearchResults:", err);
      }
    }

    // Only update state and Redux if LandId has changed
  if (LandId && LandId !== this.state.localLandId) {
    this.setState({ localLandId: LandId });
    this.props.setPaymentField({ field: "LandId", value: LandId });
  }
  }

  loadDeals = () => {};

  checkStageClass = (id) => {
    let show = this.props.show;

    let className = "row1  justify-content-center p-1 ";
    if (show === this.searchForm) {
      className += id === "stage1" ? "sel_circle" : "def_circle";
    }
    if (show === this.searchResults) {
      className += id === "stage2" ? "sel_circle" : "def_circle";
    }
    if (show === this.paymentDetails) {
      className += id === "stage3" ? "sel_circle" : "def_circle";
    }
    if (show === this.paymentsConfirm) {
      className += id === "stage4" ? "sel_circle" : "def_circle";
    }

    //console.log("show", show);
    //console.log("className", className);

    return className;
  };

  checkStageDescClass = (id) => {
    let show = this.props.show;

    let className = "form-row justify-content-center  p-0 ";
    if (show === this.searchForm) {
      className += id === "stageDesc1" ? "sel_desc" : "def_desc";
    }
    if (show === this.searchResults) {
      className += id === "stageDesc2" ? "sel_desc" : "def_desc";
    }
    if (show === this.paymentDetails) {
      className += id === "stageDesc3" ? "sel_desc" : "def_desc";
    }
    if (show === this.paymentsConfirm) {
      className += id === "stageDesc4" ? "sel_desc" : "def_desc";
    }

    return className;
  };

  endCurrentStage = (showStage) => {
    /* redux
    this.setState((currentState) => {
      return { show: showStage };
    });
    */

    this.props.setShow(showStage);
  };

  updateSearchLandResults = (searchResultsTable, additionSearchResults) => {
    /* redux
    this.setState({
      searchResult: searchResultsTable,
      additionSearchResults: additionSearchResults,
    });
    */

    this.props.setSearchResult(searchResultsTable);
    this.props.setAdditionSearchResults(additionSearchResults);

  };

  updateLandSearch = (data) => {
    /* redux
    this.setState({
      land_no: data.Land_No,
      block_no: data.Block_No,
      LGA: data.LGA,
      SurveyPlan_No: data.SurveyPlan_No,
      CofO_No: data.CofO_No
    })
      */

    this.props.setDataField({ field: 'Land_No', value: data.Land_No });
    this.props.setDataField({ field: 'Block_No', value: data.Block_No });
    this.props.setDataField({ field: 'LGA', value: data.LGA });
    this.props.setDataField({ field: 'SurveyPlan_No', value: data.SurveyPlan_No });
    this.props.setDataField({ field: 'CofO_No', value: data.CofO_No });
  }

  updatePaymentResults = (paymentResult) => {
    /* redux
    this.setState({
      paymentResult: paymentResult
    });
    */

    this.props.setPaymentResult(paymentResult);
  };

  updateBillingDetails = (FirstName, LastName, Email, IDNumber, IDType) => {

    /*redux
    this.setState({
      FirstName: FirstName,
      LastName: LastName,
      IDNumber: IDNumber,
      IDType: IDType,
      Email: Email
    });
    */


    /*
    this.props.setFirstName(FirstName);
    this.props.setLastName(LastName);
    this.props.setEmail(LastName);
    this.props.setIDNumber(LastName);
    this.props.setIDType(LastName);
    */

    /*
    this.props.setPaymentField({field:"FirstName", value: FirstName});
    this.props.setPaymentField({field:"LastName", value: LastName});
    this.props.setPaymentField({field:"LastName", value: LastName});
    this.props.setPaymentField({field:"LastName", value: LastName});
    this.props.setPaymentField({field:"LastName", value: LastName});
    */
  };

  updateErrorMessage = (
    title,
    message,
    linkTo = "",
    linkTitle = "",
    linkClass = "",
    prevStage = ""
  ) => {
    console.log("Error=" + title + ",,," + message);
    /* redux
    this.setState({
      errorTitle: title,
      errorMessage: message,
      errorLinkTo: linkTo,
      errorLinkTitle: linkTitle,
      errorLinkClassName: linkClass,
      prevStage: prevStage
    });
    */

this.props.setErrorState({
  errorTitle: title,
  errorMessage: message,
  errorLinkTo: linkTo,
  errorLinkTitle: linkTitle,
  errorLinkClassName: linkClass,
  prevStage: prevStage,
});

  };

  backToPrevStage = (prevStage) => {

    if (prevStage === '')
      prevStage = "searchForm";

    console.log("prevStage=" + prevStage);
    //this.SetState({ show: prevStage, propertyNum: propertyNum });
    /* redux
    this.setState({
      show: prevStage
    });
    */
    //this.props.returnFromError(prevStage);
    this.props.setShow(prevStage);

    // this.setState((currentState, prop) => {
    //   return { show: prevStage, propertyNum: propertyNum };
    // });
    //let p = this.state.propertyNum;
    //console.log("p=" + p);
  };

  clickSearchLand = ({ currentTarget: input }) => {
    var propertyNum = document.getElementById("txtLandNumber").value;
    getLandRegistarReport(propertyNum);
  };

  changePaymentForm = () => {
    console.log("changFirst function:");
    //redux this.setState({ show: this.paymentsConfirm });
    this.props.setShow(this.paymentsConfirm);
  };

  updateStateParams = (receiptId, callback) => {
    //redux this.setState({receiptId: receiptId}, callback);
    //this.state.receiptId = receiptId;
    //this.state.feeName = feeName;

    this.props.setReceiptId(receiptId);
  if (callback) callback();

  };

  updateShowCase = (show) => {
    //redux this.setState({ show: show});
    this.props.setShow(show);
  };

  render() {
    const { show, searchResult, additionSearchResults, receiptId, FirstName, LastName, Email, IDNumber, IDType } = this.props;
    const LandId = this.state.localLandId;
    let searchJSON = "";
    let additionSearchJSON = "";
    let propertyName = "";
    let landid = "";
    let feeValue = "";
    let ownerId = this.context.OwnerId;
    let webUserId = this.context.UID;
    let billingDetails = this.props.billingDetails;

    const help_sign = loadImage("help_sign.png");

    /* before redux
    if (searchResult !== undefined) {
      searchJSON = JSON.parse(searchResult);
      if (searchJSON[0] !== undefined && searchJSON[0].LAND_NO !== undefined)
        propertyName = searchJSON[0].LAND_NO;
      if (searchJSON[0] !== undefined && searchJSON[0].LAND_ID !== undefined)
        landid = searchJSON[0].LAND_ID;
    }
    if (additionSearchResults) {
      additionSearchJSON = JSON.parse(additionSearchResults);

      if (
        additionSearchJSON !== undefined &&
        additionSearchJSON.Table1 !== undefined &&
        additionSearchJSON.Table1[0] !== undefined
      )
      {
        if (additionSearchJSON.Table1[0].LAND_NO !== undefined)
          propertyName = additionSearchJSON.Table1[0].LAND_NO;

        if (additionSearchJSON.Table1[0].LAND_ID !== undefined)
          landid = additionSearchJSON.Table1[0].LAND_ID;
      }

      if (
        additionSearchJSON !== undefined &&
        additionSearchJSON.Table2 !== undefined &&
        additionSearchJSON.Table2[0] !== undefined &&
        additionSearchJSON.Table2[0].VALUE !== undefined
      )
        feeValue = additionSearchJSON.Table2[0].VALUE;
        this.props.setFeeValue(feeValue);
    }*/

    return (
      <React.Fragment>
        <div id="LandRegistryWrapper">
          <div id={this.paymentPageId}>
            
            <div id="TitleAndHelpDiv" /*style={{ display: 'flex', gap: '35px'}}*/>
              <div className="LandRegistryTitle">Lands Register Printout</div>
              <img className="HelpSignImg" src={help_sign} alt="User guide" 
              onClick={() => window.open('/ANAMGIS/Land search guidelines 04.05.2025.pdf', '_blank')}/>
            </div>
            <div id="LandRegistryMain">
              <div id="Content">
                <MobileView>
                <div className="LandRegistryComponentTitle">
                    {show === this.searchForm ? 
                      ("Search property") : ("")  
                    }
                    {show === this.searchResults ? 
                      ("Confirm transaction") : ("")  
                    }
                    {show === this.paymentDetails ? 
                      ("Provide payment details") : ("")  
                    }
                    {show === this.paymentsConfirm ? 
                      ("Download your printout") : ("")  
                    }
                  </div>  
              {show !== this.showError ? (
                  <div className="LandRegistryStages">
                    <div id="LandRegistryStages">
                      <div
                        id="stage1"
                        className={this.checkStageClass("stage1")}
                      >
                        <div className="stageNum">1</div>
                      </div>

                      <div className="row1">
                        <div className="stage_line"></div>
                      </div>
                      <div
                        id="stage2"
                        className={this.checkStageClass("stage2")}
                      >
                        <div className="stageNum">2</div>
                      </div>

                      <div className="row1">
                        <div className="stage_line"></div>
                      </div>
                      <div
                        id="stage3"
                        className={this.checkStageClass("stage3")}
                      >
                        <div className="stageNum">3</div>
                      </div>
                      <div className="row1">
                        <div className="stage_line"></div>
                      </div>
                      <div
                        id="stage4"
                        className={this.checkStageClass("stage4")}
                      >
                        <div className="stageNum">4</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                </MobileView>
                <div id="LandRegistryData">
                  {show === this.searchForm ? (
                    <div>
                      <SearchLandForm
                        updateShowCase={this.endCurrentStage}
                        nextStage={this.searchResults}
                        errorStage={this.showError}
                        updateSearchLandResults={this.updateSearchLandResults}
                        updateErrorMessage={this.updateErrorMessage}
                        updateLandSearch = {this.updateLandSearch}
                        propertyNum={propertyName}
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  {show === this.searchResults ? (
                    <div>
                      <SearchLandResultsForm
                        updateShowCase={this.endCurrentStage}
                        nextStage={this.paymentDetails}
                        errorStage={this.showError}
                        updateErrorMessage={this.updateErrorMessage}
                        backToPrevStage={this.backToPrevStage}
                        prevStage={this.searchForm}
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  {show === this.paymentDetails ? (
                    <div>
                      <PaymentDetailsForm
                        propertyNumber={propertyName}
                        updateShowCase={this.endCurrentStage}
                        updateBillingDetails={this.updateBillingDetails}
                        nextStage={this.paymentsConfirm}
                        errorStage={this.showError}
                        updateStateParams={this.updateStateParams}
                        updateErrorMessage={this.updateErrorMessage}
                        updatePaymentResults={this.updatePaymentResults}
                        backToPrevStage={this.backToPrevStage}
                        prevStage={this.searchResults}
                        OwnerId={ownerId}
                        WebUserId={webUserId}
                        LandId = {LandId}
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  {show === this.paymentsConfirm ? (
                    <div>
                      <PaymentConfirmForm
                        propertyNum={LandId}
                        errorStage={this.showError}
                        updateErrorMessage={this.updateErrorMessage}
                        OwnerId={ownerId}
                        WebUserId={webUserId}
                        ReceiptId={receiptId}
                        BillingDetails={billingDetails}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <BrowserView>
                {show !== this.showError ? (
                  <div className="LandRegistryStages">
                    <div id="LandRegistryStages">
                      <div
                        id="stage1"
                        className={this.checkStageClass("stage1")}
                      >
                        <div className="stageNum">1</div>
                      </div>

                      <div className="row1">
                        <div className="stage_line"></div>
                      </div>
                      <div
                        id="stage2"
                        className={this.checkStageClass("stage2")}
                      >
                        <div className="stageNum">2</div>
                      </div>

                      <div className="row1">
                        <div className="stage_line"></div>
                      </div>
                      <div
                        id="stage3"
                        className={this.checkStageClass("stage3")}
                      >
                        <div className="stageNum">3</div>
                      </div>
                      <div className="1">
                        <div className="stage_line"></div>
                      </div>
                      <div
                        id="stage4"
                        className={this.checkStageClass("stage4")}
                      >
                        <div className="stageNum">4</div>
                      </div>
                    </div>
                    <div id="LandRegistryStagesDescription">
                      <div
                        id="stageDesc1"
                        className={this.checkStageDescClass("stageDesc1")}
                      >
                        {" "}
                        <span>
                          Search <br /> land/property
                        </span>
                      </div>
                      <div className="rowStage mt-4"></div>
                      <div
                        id="stageDesc2"
                        className={this.checkStageDescClass("stageDesc2")}
                      >
                        Confirm transaction
                      </div>
                      <div className="rowStage mt-4"></div>
                      <div
                        id="stageDesc3"
                        className={this.checkStageDescClass("stageDesc3")}
                      >
                        Provide payment details
                      </div>
                      <div className="rowStage mt-4"></div>
                      <div
                        id="stageDesc4"
                        className={this.checkStageDescClass("stageDesc4")}
                      >
                        {" "}
                        Download your printout{" "}
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                </BrowserView>
                <input
                  type="Hidden"
                  name="DpfFileUrlHidden"
                  id="DpfFileUrlHidden"
                />
              </div>
            </div>
          </div>
          {show === this.showError ? (
            <div>
              <ErrorPopupForm
                /*errorTitle={this.props.errorTitle}
                errorMessage={this.props.errorMessage}
                errorLinkTo={this.props.errorLinkTo}
                errorLinkTitle={this.props.errorLinkTitle}
                errorLinkClassName={this.props.errorLinkClassName}*/
                backToPrevStage={this.backToPrevStage}
                /*prevStage={this.props.prevStage}*/
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </React.Fragment>
    );
  }

}

// map Redux state to component props
const mapStateToProps = (state) => {
  const landSearch = state.landSearch;
  const payment = state.payment;

  return {
    FirstName: payment.data.FirstName,
    IDNumber: payment.data.IDNumber,
    IDType: payment.data.IDType,
    LastName: payment.data.LastName,
    Email: payment.data.Email,

    show: landSearch.show,  
    isFlushed: state.landSearch.isFlushed,
    additionSearchResults: state.landSearch.additionSearchResults,
    searchResult: state.landSearch.searchResult,
    data: state.landSearch.data,
    paymentResult: state.landSearch.paymentResult,
    receiptId: state.landSearch.receiptId
  }
};

// map dispatch to props (optional if you just want dispatch function)
const mapDispatchToProps = {
  setShow,
  setIsFlushed, 
  setAdditionSearchResults, 
  setSearchResult, 
  setDataField, 
  setPaymentResult, 
  setErrorState, 
  setReceiptId,
  setFeeValue,
  setPaymentField,
  returnFromError
};


LandRegister.contextType = UserContext;
//export default LandRegister;
export default connect(mapStateToProps, mapDispatchToProps)(LandRegister);
